import { LOCAL_STORAGE_PREFIX } from 'constants/global';

export function setWindowVar(name, value) {
  window[`${LOCAL_STORAGE_PREFIX}${name}`] = value;
}
